import React, { useCallback, useState, useEffect } from "react";
import { Loading } from "../../../../../components/Loading";
import styles from "./styles.module.scss";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService.js";
import Swal from "sweetalert2";
import { PiCopySimple } from "react-icons/pi";
import { FaArrowRotateLeft } from "react-icons/fa6";
import DeliveryTypeEnum from "../../../../../enums/DeliveryTypeEnum.js"

const Yampi = () => {
  const api = new BrComerceApiService();

  const [loading, setLoading] = useState(false);

  const [copiedApiKey, setCopiedApiKey] = useState(false);
  const [generatedApiKey, setGeneratedApiKey] = useState("");
  const [generatedApiKeyOK, setGeneratedApiKeyOK] = useState("");

  const [zipCode, setZipCode] = useState("");
  const [zipCodeOK, setZipCodeOK] = useState("");
  const [zipCodeError, setZipCodeError] = useState("");

  const [activeInsurance, setActiveInsurance] = useState(false);

  const [sedex, setSedex] = useState("");
  const [sedexOK, setSedexOK] = useState("");

  const [pac, setPac] = useState("");
  const [pacOK, setPacOK] = useState("");

  const [mini, setMini] = useState("");
  const [miniOK, setMiniOK] = useState("");

  const [ownDelivery, setOwnDelivery] = useState("");
  const [ownDeliveryOK, setOwnDeliveryOK] = useState("");

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(generatedApiKey);
    setCopiedApiKey(true);
  };

  const handleInputService = useCallback((e, service) => {
    const valueNumber = e.currentTarget.value.replace(/\D/g, "");
    if (valueNumber > 99) {
      return;
    }
    switch (service) {
      case DeliveryTypeEnum.SEDEX:
        if (valueNumber === "") {
          setSedex("");
          setSedexOK("vazio");
        } else {
          setSedex(valueNumber);
          setSedexOK("ok");
        }
        break;
      case DeliveryTypeEnum.PAC:
        if (valueNumber === "") {
          setPac("");
          setPacOK("vazio");
        } else {
          setPac(valueNumber);
          setPacOK("ok");
        }
        break;
      case DeliveryTypeEnum.PACMINI:
        if (valueNumber === "") {
          setMini("");
          setMiniOK("vazio");
        } else {
          setMini(valueNumber);
          setMiniOK("ok");
        }
        break;
      case DeliveryTypeEnum.OWN_DELIVERY:
        if (valueNumber === "") {
          setOwnDelivery("");
          setOwnDeliveryOK("vazio");
        } else {
          setOwnDelivery(valueNumber);
          setOwnDeliveryOK("ok");
        }
        break;

      default:
        return;
    }
  }, []);

  const handleSubmit = useCallback(
    async (key, value) => {
      api.makeHttpRequest({
        url: "/yampi/config",
        method: "POST",
        data: {
          key: key,
          value: value
        }
      });
    },
    [api]
  );

  const sendData = async () => {
    try {
      await Promise.all([
        handleSubmit("ZIP_CODE", zipCode),
        handleSubmit("ADD_DAYS_SEDEX", sedex),
        handleSubmit("ADD_DAYS_PAC", pac),
        handleSubmit("ADD_DAYS_PACMINI", mini),
        handleSubmit("ADD_DAYS_OWN_DELIVERY", ownDelivery),
        activeInsurance
          ? handleSubmit("IS_ACTIVE_INSURANCE", "true")
          : handleSubmit("IS_ACTIVE_INSURANCE", "false")
      ]);

      Swal.fire({
        title: "Sucesso!",
        text: "Configurações cadastradas com sucesso.",
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Não foi possível fazer a deleção do envio."
      });
    }
  };

  const handleGenerateApiKey = async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        method: "POST",
        url: `/yampi`
      });

      setGeneratedApiKey(response.value);
      setGeneratedApiKeyOK("ok");
    } catch (e) {
      Swal.fire({
        title: "Erro!",
        text: "Não foi possível gerar a API Key.",
        icon: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const loadingConfig = useCallback(async () => {
    await Promise.all([
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/API_KEY`
        })
        .then(res => {
          if (res) {
            setGeneratedApiKey(res);
            setGeneratedApiKeyOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/ZIP_CODE`
        })
        .then(zipCode => {
          if (zipCode) {
            setZipCode(zipCode);
            setZipCodeOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/ADD_DAYS_PACMINI`
        })
        .then(res => {
          if (res) {
            setMini(res);
            setMiniOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/ADD_DAYS_PAC`
        })
        .then(res => {
          if (res) {
            setPac(res);
            setPacOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/ADD_DAYS_SEDEX`
        })
        .then(res => {
          if (res) {
            setSedex(res);
            setSedexOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/ADD_DAYS_OWN_DELIVERY`
        })
        .then(res => {
          if (res) {
            setOwnDelivery(res);
            setOwnDeliveryOK("ok");
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/yampi/config/IS_ACTIVE_INSURANCE`
        })
        .then(active => {
          if (active === "true") {
            setActiveInsurance(true);
          }
        })
    ]);
  }, [api]);

  useEffect(() => {
    if (!copiedApiKey) return;

    const timeout = setTimeout(() => {
      setCopiedApiKey(false);
    }, 2500);

    return () => clearTimeout(timeout);
  }, [copiedApiKey]);

  useEffect(() => {
    setLoading(true);

    loadingConfig()
      .then(() => {
        console.log("Configurações ok");
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Não foi possível carregar as informações da loja Yampi.",
          icon: "error"
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleInputZipCode = useCallback(e => {
    const regEx = /[^0-9]/;
    const zipCode = e.currentTarget.value.replace(regEx, "").trim();

    if (zipCode.length != 8) {
      setZipCode(zipCode);
      setZipCodeError("CEP inválido");
      setZipCodeOK("vazio");
    } else {
      const parsedZipCode = `${zipCode.substr(0, 5)}-${zipCode.substr(5, 3)}`;
      setZipCode(parsedZipCode);
      setZipCodeError("");
      setZipCodeOK("ok");
    }
  }, []);

  useEffect(() => {
    window.setPageTitle("Integrações | Yampi");
  }, []);

  return (
    <>
      <Loading loading={loading} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentHeader}>
            <h2>Configurações</h2>
          </div>
          <div className={styles.contentBody}>
            <section>
              <div>
                <p>
                  A chave gerada abaixo é única e intransferível. Lembre-se: ao
                  gerar uma nova chave, a antiga sempre será desabilitada.
                </p>
                <div className={styles.contentSection}>
                  <div
                    className={styles.inputCustom}
                    onClick={handleCopyApiKey}
                    role={generatedApiKeyOK}
                  >
                    <input
                      type="text"
                      placeholder=""
                      value={generatedApiKey}
                      disabled
                    />
                    <PiCopySimple />
                    <div>
                      <p className={styles.textClipped}>
                        {copiedApiKey && !!generatedApiKey
                          ? "Copiado com sucesso!"
                          : ""}
                      </p>
                    </div>
                  </div>
                  <button
                    className={styles.generateBtn}
                    type="button"
                    onClick={handleGenerateApiKey}
                  >
                    <FaArrowRotateLeft size={18} />
                    <span>Gerar Nova Chave</span>
                  </button>
                </div>
              </div>

              <div>
                <h4>Informe o CEP do remetente.</h4>
                <div className={styles.contentSection}>
                  <div className={styles.input} role={zipCodeOK}>
                    <input
                      type="text"
                      name="zipCode"
                      value={zipCode}
                      onChange={handleInputZipCode}
                      placeholder="Digite o CEP do remetente"
                    />
                  </div>
                  {zipCodeError && (
                    <p className={styles.error}>{zipCodeError}</p>
                  )}
                </div>
              </div>
              <div>
                <h4>Configuração de Seguro</h4>
                <p style={{ marginTop: "16px" }}>
                  Abaixo é possível ativar ou desatitvar a cotação de frete com
                  Seguro. Essa opção é válida para todos os fretes <br /> que
                  são cotados.
                </p>
                <div className={styles.contentSection}>
                  <div className={styles.switchOption}>
                    <label className={styles.switch}>
                      <input
                        type="checkbox"
                        onChange={event =>
                          setActiveInsurance(event.target.checked)
                        }
                        checked={activeInsurance}
                        disabled={!generatedApiKey}
                      />
                      <span
                        className={`${styles.slider} ${styles.round}`}
                      ></span>
                    </label>
                    {activeInsurance ? "Ativado" : "Desativado"}
                  </div>
                </div>
              </div>

              <div>
                <h4>Configurações adicionais de frete</h4>
                <p style={{ marginTop: "16px" }}>
                  Abaixo é possível indicar a quantidade de dias adicionais para
                  cada tipo de envio. Essa opção é particularmente útil para{" "}
                  <br /> refletir nas cotações o seu prazo de manipulação dos
                  pedidos.
                </p>
                <div className={styles.contentSection}>
                  <div className={styles.addDaysContainer}>
                    <div
                      className={`${styles.input} ${sedexOK === "notOK"
                        ? styles.formSelectError
                        : sedexOK === "ok"
                          ? styles.selectOk
                          : ""
                        }`}
                    >
                      <input
                        type="number"
                        name="sedex"
                        value={sedex}
                        onChange={(e) => handleInputService(e, DeliveryTypeEnum.SEDEX)}
                        placeholder="Expresso"
                        min={0}
                        max={99}
                      />
                    </div>
                    <div
                      className={`${styles.input} ${pacOK === "notOK"
                        ? styles.formSelectError
                        : pacOK === "ok"
                          ? styles.selectOk
                          : ""
                        }`}
                    >
                      <input
                        type="number"
                        name="pac"
                        value={pac}
                        onChange={(e) => handleInputService(e, DeliveryTypeEnum.PAC)}
                        placeholder="Economico"
                        min={0}
                        max={99}
                      />
                    </div>
                    <div
                      className={`${styles.input} ${miniOK === "notOK"
                        ? styles.formSelectError
                        : miniOK === "ok"
                          ? styles.selectOk
                          : ""
                        }`}
                    >
                      <input
                        type="number"
                        name="mini"
                        value={mini}
                        onChange={(e) => handleInputService(e, DeliveryTypeEnum.PACMINI)}
                        placeholder="Super Econômica"
                        min={0}
                        max={99}
                      />
                    </div>

                    <div
                      className={`${styles.input} ${ownDeliveryOK === "notOK"
                        ? styles.formSelectError
                        : ownDeliveryOK === "ok"
                          ? styles.selectOk
                          : ""
                        }`}
                    >
                      <input
                        type="number"
                        name="ownDelivery"
                        value={ownDelivery}
                        onChange={(e) => handleInputService(e, DeliveryTypeEnum.OWN_DELIVERY)}
                        placeholder="Super expressa"
                        min={0}
                        max={99}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.buttonWrapper}>
                <button
                  type="submit"
                  onClick={sendData}
                  className={styles.button}
                  disabled={!generatedApiKey || zipCodeOK !== "ok"}
                >
                  Salvar
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export { Yampi };
